import React, { useEffect, useState } from "react";
import * as S from "screens/funilPropostas/components/Filtro/styles";
import { defaultFiltersVisitas, FiltersVisitasI } from "screens/visitas/utils";
import { DatePicker } from "screens/perfilAutonomo/components/DatePicker";
import { fetchListarProdutos } from "screens/visitas/api/getListarProdutos";
import * as IconsSVG from "../../../../assets/iconsSVG";
import SelectComponent from "../../../../components/selectAutoCompleteG";

export const FiltroVisitas = ({
  isOpen,
  filters,
  onConfirm,
}: {
  isOpen: boolean;
  filters: FiltersVisitasI;
  onConfirm: (args: FiltersVisitasI) => void;
}) => {
  const [tempFilters, setTempFilters] = useState<FiltersVisitasI>(
    defaultFiltersVisitas
  );
  const { data: empreendimentosOptions, isLoading: loadingEmpreendimentos } =
    fetchListarProdutos(true);

  useEffect(() => {
    if (isOpen) setTempFilters(filters);
  }, [isOpen]);

  const handleClear = () => {
    setTempFilters(defaultFiltersVisitas);
  };

  const handleConfirm = () => {
    onConfirm(tempFilters);
  };

  return (
    <S.Content>
      <S.Row style={{ justifyContent: "space-between" }}>
        <IconsSVG.FilterModalIcon />
        <S.TextFilter>Filtros</S.TextFilter>
        <S.ButtonClear onClick={handleClear}>Limpar</S.ButtonClear>
      </S.Row>
      <S.SpaceY space={16} />
      <p>Empreendimento</p>
      <S.Row>
        <SelectComponent
          borderRadius="8px"
          data={
            empreendimentosOptions?.data?.map((item: any) => ({
              value: item?.idEmpreendimento,
              label: item?.nomeEmpreendimento,
            })) || []
          }
          placeholder="Selecione"
          value={empreendimentosOptions?.data
            ?.map((item: any) => ({
              value: item?.idEmpreendimento,
              label: item?.nomeEmpreendimento,
            }))
            ?.find((item: any) => item?.value === tempFilters.idEmpreendimento)}
          onChange={(item: any) => {
            setTempFilters((prev) => ({
              ...prev,
              idEmpreendimento: item?.value,
            }));
          }}
          disabled={!empreendimentosOptions?.data || loadingEmpreendimentos}
        />
      </S.Row>
      <S.SpaceY space={16} />
      <p>De</p>
      <S.Row>
        <DatePicker
          onChange={(val) => {
            setTempFilters((prev) => ({
              ...prev,
              dataDe: val,
            }));
          }}
          value={tempFilters.dataDe}
        />
      </S.Row>
      <S.SpaceY space={16} />
      <p>Até</p>
      <S.Row>
        <DatePicker
          onChange={(val) => {
            setTempFilters((prev) => ({
              ...prev,
              dataAte: val,
            }));
          }}
          value={tempFilters.dataAte}
        />
      </S.Row>
      <S.SpaceY space={16} />
      <S.Row>
        <S.ButtonFilter onClick={handleConfirm}>Aplicar Filtro</S.ButtonFilter>
      </S.Row>
    </S.Content>
  );
};
